<template>
    <div>
        <div v-if="!response" class="no-answer">
            <span>
                Not Answered
            </span>
        </div>
        <div class="stars">
            <StarActiveIcon v-for="i in starValue(response)" :color="isSurvey ? '#709F34' : '#833e93'" :key="'active' + i" ></StarActiveIcon>
            <StarInactiveIcon v-for="j in (5 - starValue(response))" :key="'inactive' + j" class="el-icon-star-off"></StarInactiveIcon>
            <label>
                {{ question.label[starValue(response) - 1] }}
            </label>
        </div>
    </div>
</template>

<script>

import Icons from '../icon'

export default {   
    name: 'star-partial',

    props: {
		response: {
			type: Object,
        },
        // Content object for this question
		question: {
			type: Object,
			required: true
        },
        isSurvey: {
            type: Boolean,
            default: false
        }
    },
    
    methods: {
		starValue(response) {
            if(response && Object.keys(response).length > 0)
                return parseInt(Object.keys(response)[0]) + 1
			return 0
		}
    },
    
    components: {
		...Icons,
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
